import { render } from "./AnnexAlarmStatusHelperIcon.vue?vue&type=template&id=2115130e&ts=true"
import script from "./AnnexAlarmStatusHelperIcon.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmStatusHelperIcon.vue?vue&type=script&lang=ts"

import "./AnnexAlarmStatusHelperIcon.vue?vue&type=style&index=0&id=2115130e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__